module.exports = __webpack_public_path__ + "static/media/user.49c4238f.svg";